import React, { useEffect } from "react";
import logo from "../Assets/Logo/logo.webp";
import arrow_popup from "../Assets/arrow_popup.gif";
import ReactPlayer from "react-player";

const Thankyou = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    window.fbq("track", "Lead");
  }, []);

  return (
    <>
      <div className="container">
        <section className="mt-5">
          <div className="alignment">
            <img src={logo} alt="Social Social" className="logo" />
          </div>
        </section>
        <section className="mt-5">
          <div className="alignment">
            <h6 className="thankstitle">"CONGRATULATIONS"</h6>
            <p className="thankstitle1">
              Your Call with our Expert team to become a member of &nbsp;
              <span className="freecall">TiE Chennai’s Personal Board</span>
              <br />
              <span>has been confirmed.</span>
            </p>

            <p className="thankstitle1">
              Kindly check Your Email & Whatsapp for the related information
            </p>
            <div className="my-5">
              {/* <ReactPlayer
                url="https://vimeo.com/1051073805"
                className="videoalignment"
              /> */}
              <iframe
                // ref={iframeRef}
                src="https://player.vimeo.com/video/1051073805?badge=0&autopause=0&player_id=0&app_id=58479"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                className="videoalignment"
                title="TiE Chennai Personal Board - VSL"
              ></iframe>
            </div>
          </div>
          <div className="d-flex flex-lg-row flex-column gap-lg-5 justify-content-center">
            {/* <a
              href="https://socialeagleacademy.com/#/Results"
              target="_blank"
              className="thank_button_center"
            >
              <button className="thank_button">
                <img
                  src={arrow_popup}
                  alt="Social Social"
                  className="gif_image me-3"
                />
                Watch Success Stories
              </button>
            </a> */}
            <a
              href="https://chat.whatsapp.com/E3ID87mqkaICZY7UnRv4kF"
              target="_blank"
              className="thank_button_center"
            >
              <button className="thank_button ">
                <img
                  src={arrow_popup}
                  alt="Social Social"
                  className="gif_image me-3"
                />
                Join our FREE Community
              </button>
            </a>
          </div>
        </section>
      </div>
    </>
  );
};

export default Thankyou;
